<div class="document-viewer-page-screen">
  <section class="document-viewer-page">
    <info-page-header [label]="label" [navigateTo]="navigateTo"></info-page-header>
    <document-viewer [url]="url"></document-viewer>
  </section>
</div>
